export const taskReference = (task: { id: string; number?: number }): string =>
  task.number ? `TASK-${task.number}` : task.id;

export const issueReference = (issue: { id: string; number?: number }): string =>
  issue.number ? `OPS-${issue.number}` : issue.id;
